import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Rectangle } from '../components/Rectangle';
export function taxonomyRender(datum, nodeRendererOptions = {}) {
    if (Object.keys(nodeRendererOptions).length !== 0) {
        throw new Error('This should never happen');
    }
    const minSize = { width: 120, height: 20 };
    const taxonomy = getTaxonomy(datum, minSize);
    const label = getLabel(datum, minSize);
    const width = Math.max(taxonomy.width, label.width);
    const height = Math.max(taxonomy.height, label.height);
    const nbTaxonomies = getNbTaxonomies(datum, width, minSize);
    return {
        width,
        height,
        component: (_jsxs("g", { children: [_jsx(Rectangle, { width: width, height: height, style: {
                        ...{ stroke: 'black', fill: 'white' },
                        ...(datum.style || {}),
                    } }), label.content, taxonomy.content, nbTaxonomies.content] })),
    };
}
function getNbTaxonomies(datum, width, minSize) {
    return {
        width: minSize.width,
        height: minSize.height,
        content: (_jsx("text", { x: width, y: -5, textAnchor: "end", stroke: "none", fontSize: "14", fill: "#00008B" // dark blue
            , fontStyle: 'bold', "font-family": "Arial, Helvetica, sans-serif", children: datum.nbTaxonomies })),
    };
}
function getLabel(datum, minSize, options = {}) {
    const { spacingHorizontal } = {
        spacingHorizontal: 8,
        ...options,
    };
    if (datum.rank === '') {
        return {
            width: 0,
            height: 0,
            content: null,
        };
    }
    return {
        width: minSize.width,
        height: minSize.height,
        content: (_jsx("text", { x: spacingHorizontal / 2, y: -6, textAnchor: "start", stroke: "none", fontSize: "14", fill: "grey", fontStyle: 'italic', "font-family": "Arial, Helvetica, sans-serif", children: datum.rank })),
    };
}
function getTaxonomy(datum, minSize, options = {}) {
    const { font, fontSize, spacingHorizontal } = {
        font: 'Arial, Helvetica, sans-serif',
        fontSize: 16,
        spacingHorizontal: 8,
        ...options,
    };
    if (datum.name === '') {
        return {
            width: 0,
            height: 0,
            content: null,
        };
    }
    let { width, height } = getStringSize(datum.name, {
        font,
        fontSize,
        spacingHorizontal,
    });
    let textWith = width;
    let positionX = spacingHorizontal / 2;
    if (height <= minSize.height) {
        height = minSize.height;
    }
    if (width <= minSize.width) {
        width = minSize.width;
        positionX = (width - textWith + spacingHorizontal) / 2;
    }
    return {
        width: width,
        height: height,
        content: (_jsx("svg", { height: height, width: width, "dominant-baseline": "central", children: _jsx("text", { x: positionX, y: height / 2, stroke: "none", fontSize: fontSize, fill: "black", "font-family": font, children: datum.name }) })),
    };
}
function getStringSize(text, options) {
    const { font = 'Arial, Helvetica, sans-serif', fontSize = 16, spacingHorizontal = 8, } = options;
    const tempElement = document.createElement('span');
    tempElement.style.font = `${fontSize}px ${font}`;
    tempElement.style.visibility = 'hidden';
    tempElement.style.position = 'absolute';
    tempElement.style.top = '-9999px';
    tempElement.style.left = '-9999px';
    tempElement.textContent = text;
    document.body.appendChild(tempElement);
    let { height, width } = tempElement.getBoundingClientRect();
    document.body.removeChild(tempElement);
    return { width: width + spacingHorizontal, height };
}
//# sourceMappingURL=taxonomyRender.js.map